module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-content"
  }, [_c('navbar', {
    attrs: {
      "title": _vm.$t('basic.navText')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "account-wrapper"
  }, [_c('div', {
    staticClass: "account-form success-content"
  }, [_c('img', {
    staticClass: "success-img",
    attrs: {
      "src": require("../../assets/success.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "success-title"
  }, [_vm._v(_vm._s(_vm.$t("basic.successText")))]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('button', {
    staticClass: "czur-style",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backToBasic
    }
  }, [_vm._v(_vm._s(_vm.$t("basic.finishText")))])])])]), _vm._v(" "), _c('LoginCheck', {
    on: {
      "nologin": _vm.withOutLogin
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0b639c1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b639c1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/updateSuccess.vue
// module id = 160
// module chunks = 1 2